import {
  DestinyRecipesWatcher,
  DestinyRecipesWatcherConfig,
  DestinyRecipesWatcherType
} from './destiny-recipes-watcher';
import { DataService } from '../services/data.service';
import { DestinyItemCategory } from '../services/destinyItemCategory';
import {
  armorShapeMap,
  armorShapeMapOrdered,
  DestinyArmorAppraisalRating,
  DestinyRecipesItem
} from '../types/destiny-recipes-item';
import { ToastrService } from 'ngx-toastr';
import { ItemState } from 'bungie-api-ts/destiny2';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

export interface ArmorQualityWatcherConfig extends DestinyRecipesWatcherConfig {
  type: DestinyRecipesWatcherType.ARMOR_QUALITY;
  data: DestinyArmorAppraisalRating;
}

export class ArmorQualityWatcher extends DestinyRecipesWatcher {

  config: ArmorQualityWatcherConfig;
  gearCategories = [
    [DestinyItemCategory.TITAN, DestinyItemCategory.A_LEGS],
    [DestinyItemCategory.TITAN, DestinyItemCategory.A_CHEST],
    [DestinyItemCategory.TITAN, DestinyItemCategory.A_LEGS],
    [DestinyItemCategory.TITAN, DestinyItemCategory.A_HELMET],
    [DestinyItemCategory.HUNTER, DestinyItemCategory.A_LEGS],
    [DestinyItemCategory.HUNTER, DestinyItemCategory.A_CHEST],
    [DestinyItemCategory.HUNTER, DestinyItemCategory.A_LEGS],
    [DestinyItemCategory.HUNTER, DestinyItemCategory.A_HELMET],
    [DestinyItemCategory.WARLOCK, DestinyItemCategory.A_LEGS],
    [DestinyItemCategory.WARLOCK, DestinyItemCategory.A_CHEST],
    [DestinyItemCategory.WARLOCK, DestinyItemCategory.A_LEGS],
    [DestinyItemCategory.WARLOCK, DestinyItemCategory.A_HELMET],
  ];

  constructor(
    protected dataService: DataService,
    protected toastr: ToastrService,
    protected translateService: TranslateService
  ) {
    super(DestinyRecipesWatcherType.ARMOR_QUALITY, dataService);
  }

  protected beforeStart() {}

  protected beforeStop() {}

  protected checkConfig() {
    if (!this.config.data) {
      throw new Error('minimumQualityToKeep must be defined');
    }
    if (!Object.keys(DestinyArmorAppraisalRating).includes(this.config.data)) {
      throw new Error('minimumQualityToKeep must be a valid rating');
    }
  }

  protected inventoryUpdated() {
    const newItems = this.dataService.filterInventory({ lootAfter: this.watchFrom });
    if (!newItems?.length) { return; }
    this.gearCategories.forEach(async (categories) => {
      const newItemsInCategory = newItems.filter((i) => categories.every((cat) => i.definition.itemCategoryHashes.indexOf(cat) > -1));
      if (newItemsInCategory?.length) {
        const itemsToLock = newItemsInCategory.filter((item) => armorShapeMapOrdered[item.armorAppraisal.rating] >= armorShapeMapOrdered[this.config.data]);
        if  (itemsToLock.length > 0) {
          await this.lockItems(itemsToLock).catch((err) => {
            console.error(err);
            this.toastr.warning(this.translateService.instant('WATCHER.ARMOR_QUALITY.MISSING_LOCK'));
          });
        }
      }
    });
    this.afterUpdate();
  }

  protected async lockItems(items: DestinyRecipesItem[]): Promise<any> {
    for (const item of items) {
      try {
        await firstValueFrom(this.dataService.setItemLockState(item, true));
        (item as any).state |= ItemState.Locked;
        this.toastr.info(this.translateService.instant('WATCHER.ARMOR_QUALITY.ITEM_LOCKED', {itemName: item.definition.displayProperties.name}));
        await new Promise(r => setTimeout(r, 500));
      } catch (err) {
        console.error(err);
        this.toastr.warning(this.translateService.instant('WATCHER.ARMOR_QUALITY.ITEM_ERROR_LOCKED') + item.definition.displayProperties.name);
      }
    }
  }
}
